module.exports = __webpack_public_path__ + "static/media/weizfen.9e16361d.png";